import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";

import InputMask from "react-input-mask";

import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

function PhoneMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      //      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      //      placeholderChar={'\u2000'}
      mask="(+99) - 99999 - 99999999"
      formatChars={{ "9": "[0-9]", "-": "[0-9-]", "?": "[0-9 ]" }}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

function TextMobileMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      //      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      mask="(+99) - 99999 - 15 - 99999999"
      formatChars={{ "9": "[0-9]", "-": "[0-9-]", "?": "[0-9 ]" }}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

function CuitMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/
      ]}
    />
  );
}

const useStyles = makeStyles(theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const SubContactBasicData = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  basic_data,
  subcontact_types,
  document_types,
  client_structures,
  isParentClient,
  validateCuit,
  cuitExists,
  validateEmail,
  emailExists,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "basic_data");
  };

  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var isEmailValid = re.test(String(basic_data.email).toLowerCase());

  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      {basic_data.hansa_code ? (
        <TextField
          id="hansa_code"
          name="hansa_code"
          label="Código de Hansa"
          disabled={true}
          type="text"
          value={basic_data.hansa_code}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
        />
      ) : (
        ""
      )}

      <TextField
        id="firstname"
        name="firstname"
        label="Nombre"
        disabled={disabled}
        error={
          error !== "" && basic_data.firstname === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.firstname === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        required
        placeholder="Ingrese el nombre"
        onChange={handleChange}
        value={basic_data.firstname}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <TextField
        id="lastname"
        name="lastname"
        label="Apellido"
        disabled={disabled}
        required
        error={
          error !== "" && basic_data.lastname === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.lastname === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        placeholder="Ingrese el apellido"
        onChange={handleChange}
        value={basic_data.lastname}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Tipo de subcontacto *
        </Typography>
        <Select
          native
          name="subcontact_type_id"
          inputProps={{
            name: "subcontact_type_id",
            className: "subcontact_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && basic_data.subcontact_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.subcontact_type_id}
          input={<Input id="grouped-native-select" name="subcontact_type_id" />}
        >
          <option value="" />
          {subcontact_types.map(subcontact_type => (
            <option id={subcontact_type.id} value={subcontact_type.id}>
              {subcontact_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && basic_data.subcontact_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        //required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Tipo de documento
        </Typography>
        <Select
          native
          name="document_type_id"
          inputProps={{
            name: "document_type_id",
            className: "document_type_id"
          }}
          //error={(error !=='' && basic_data.document_type_id ==='') ? 'Debe completar este campo' :  false }
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          className="ml-2 mr-2"
          onChange={handleChange}
          //required
          disabled={disabled}
          value={basic_data.document_type_id}
          input={<Input id="grouped-native-select" name="document_type" />}
        >
          <option value="" label="Seleccione" />
          {document_types.map(document_type => (
            <option id={document_type.id} value={document_type.id}>
              {document_type.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl
        //required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Nro de documento</Typography>
        <Input
          id="document_number"
          name="document_number"
          label="Nro de documento"
          //required
          disabled={disabled}
          placeholder="Ingrese el número de documento"
          margin="normal"
          className="mr-2 mt-0 mb-0"
          InputLabelProps={{
            shrink: true
          }}
          //error={(error !=='' && basic_data.document_number ==='') ? 'Debe completar este campo' :  false }
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          value={basic_data.document_number}
          onChange={handleChange}
          onBlur={validateCuit}
        />
        {error !== "" && cuitExists && (
          <FormHelperText style={{ color: "red" }}>
            El CUIT / CUIL ya existe
          </FormHelperText>
        )}
      </FormControl>

      <FormControl>
        <TextField
          id="email"
          name="email"
          disabled={disabled}
          required
          label="Email"
          type="email"
          placeholder="Ingrese el email"
          onChange={handleChange}
          value={basic_data.email}
          error={
            error !== "" && (basic_data.email === "" || isEmailValid === false)
              ? "Debe completar este campo"
              : false
          }
          helperText={
            error !== "" && (basic_data.email === "" || isEmailValid === false)
              ? "Debe completar este valor correctamente"
              : ""
          }
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          onBlur={validateEmail}
        />

        {error !== "" && emailExists && (
          <FormHelperText style={{ color: "red" }}>
            El email ya existe para este cliente
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Telefono fijo</Typography>
        <Input
          id="phone"
          name="phone"
          type="text"
          required
          disabled={disabled}
          placeholder="Ingrese el teléfono fijo"
          margin="normal"
          className="mr-2"
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          value={basic_data.phone}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true
          }}
          error={
            error !== "" && basic_data.phone === ""
              ? "Debe completar este campo"
              : false
          }
          helperText={
            error !== "" && basic_data.phone === ""
              ? "Debe completar este valor"
              : ""
          }
        />
        {error !== "" && basic_data.phone === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Telefono móvil</Typography>
        <Input
          id="mobile"
          disabled={disabled}
          name="mobile"
          placeholder="Ingrese el teléfono móvil"
          margin="normal"
          className="mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          value={basic_data.mobile}
          onChange={handleChange}
          inputComponent={TextMobileMaskCustom}
        />
      </FormControl>

      <div className="row ml-1">
        <FormControl
          className={classes.formControl}
          inputProps={{ shrink: true }}
        >
          <Typography className={classes.typography}>Nro. Licencia</Typography>
          <Input
            id="license_number"
            name="license_number"
            label="Nro. Licencia"
            //required={ (basic_data.subcontact_type_id === '2' || basic_data.subcontact_type_id === 2) ? true : false }
            disabled={disabled}
            placeholder="Ingrese el número de licencia"
            margin="normal"
            className="mr-2 mt-0 mb-0"
            InputLabelProps={{
              shrink: true
            }}
            error={
              error !== "" &&
              (basic_data.subcontact_type_id === "2" ||
                basic_data.subcontact_type_id === 2) &&
              basic_data.license_number === ""
                ? "Debe completar este campo"
                : false
            }
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
            value={basic_data.license_number}
            onChange={handleChange}
          />
          {error !== "" &&
            (basic_data.subcontact_type_id === "2" ||
              basic_data.subcontact_type_id === 2) &&
            basic_data.license_number === "" && (
              <FormHelperText style={{ color: "red" }}>
                Debe completar este campo
              </FormHelperText>
            )}
        </FormControl>

        <TextField
          id="license_due_date"
          name="license_due_date"
          type="date"
          placeholder="Ingrese el vto de la licencia"
          label="Fecha vto. licencia"
          disabled={disabled}
          //required={ (basic_data.subcontact_type_id === '2' || basic_data.subcontact_type_id === 2) ? true : false }
          onChange={handleChange}
          value={basic_data.license_due_date}
          margin="normal"
          className="mr-2 mt-3"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
        />

        <FormControl
          className={classes.formControl}
          inputProps={{ shrink: true }}
        >
          <Typography className={classes.typography}>Cargo</Typography>
          <Input
            id="contact_relation"
            name="contact_relation"
            label="Cargo"
            disabled={disabled}
            placeholder="Ingrese el cargo"
            margin="normal"
            className="mr-2 mt-0 mb-0"
            InputLabelProps={{
              shrink: true
            }}
            //error={(error !=='' && basic_data.contact_relation ==='') ? 'Debe completar este campo' :  false }
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
            value={basic_data.contact_relation}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl
          className={classes.formControl}
          inputProps={{ shrink: true }}
        >
          <Typography className={classes.typography}>Cod. interno</Typography>
          <Input
            id="code"
            name="code"
            label="Cod. interno"
            disabled={disabled}
            placeholder="Ingrese el codigo interno"
            margin="normal"
            className="mr-2 mt-0 mb-0"
            InputLabelProps={{
              shrink: true
            }}
            //error={(error !=='' && basic_data.code ==='') ? 'Debe completar este campo' :  false }
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
            value={basic_data.code}
            onChange={handleChange}
          />
          {/*(error !=='' && basic_data.code ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>
           */}
        </FormControl>

        {client_structures.length > 0 ? (
          <FormControl
            className={classes.formControl}
            inputProps={{ shrink: true }}
          >
            <Typography className={classes.typography}>Estructura</Typography>
            <Select
              native
              name="client_structure_id"
              inputProps={{
                name: "client_structure_id",
                className: "client_structure_id"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              className="mr-2"
              onChange={handleChange}
              disabled={disabled}
              value={basic_data.client_structure_id}
              input={
                <Input id="grouped-native-select" name="client_structure_id" />
              }
            >
              <option value="" label="Seleccione" />
              {client_structures.map(client_structure => (
                <option id={client_structure.id} value={client_structure.id}>
                  {client_structure.code} - {client_structure.name}
                </option>
              ))}
            </Select>
          </FormControl>
        ) : (
          ""
        )}
        {/*(isParentClient)
          ? 
            <FormControlLabel
            className={classes.SwitchLabel}
            control={
              <Switch
                id="receive_invoice"
                value={basic_data.receive_invoice}
                checked={basic_data.receive_invoice}
                disabled={disabled}
                onChange={handleChange}
                name="receive_invoice"
                size="small"
                color="primary"
                className="ml-0 mr-0"
              />
            }
            style={{marginRight: 0, marginLeft: 0}}
            label="Recibe facturas?"
            labelPlacement="start"
            />                 
          :
            ''
        */}
      </div>
    </React.Fragment>
  );
};

SubContactBasicData.defaultProps = {
  type: "text",
  className: "",
  subcontact_types: [],
  disabled: false,
  isParentClient: true
};

SubContactBasicData.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default SubContactBasicData;
